import script from "./PluginCover.vue?vue&type=script&setup=true&lang=js"
export * from "./PluginCover.vue?vue&type=script&setup=true&lang=js"

import "./PluginCover.vue?vue&type=style&index=0&id=2edcb79c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2edcb79c"]])

export default __exports__